const BOLD_TAG_PATTERN = /<\/?(b|strong)>/gi;

const hasBalancedBoldTags = (html: string): boolean => {
  const tags: string[] = [];
  let match: RegExpExecArray | null;

  BOLD_TAG_PATTERN.lastIndex = 0;
  while ((match = BOLD_TAG_PATTERN.exec(html)) !== null) {
    const tag = match[1].toLowerCase();
    if (match[0][1] === '/') {
      if (tags.pop() !== tag) return false;
    } else {
      tags.push(tag);
    }
  }
  return tags.length === 0;
};

/**
 * CMS marks show names with attribute-free <b>/<strong>. Rewrite each balanced
 * pair to <strong><em> so show names render bold and italic. Unbalanced bold
 * markup and every other tag are left exactly as authored.
 */
export const emphasizeShowNames = (html?: string | null): string => {
  if (!html) return '';
  if (!hasBalancedBoldTags(html)) return html;
  return html.replace(BOLD_TAG_PATTERN, (tag) =>
    tag[1] === '/' ? '</em></strong>' : '<strong><em>'
  );
};
